module.exports = __webpack_public_path__ + "img/portraitmode_woman_5210.483307d9.png";